import { v4 as uuid } from '@lukeed/uuid'

import { DOC_TYPE } from '$lib/types/document'

import type { AccTemplate } from './types'



export function makeAccTemplate(values?: Partial<AccTemplate>): AccTemplate {
	
	let newData: AccTemplate = {
		id: uuid(),
		doc_type: DOC_TYPE.INVOICE,
		template_id: '000',
		user_config: { 
			style: {
				mainAccentColor: '#116001',
				// mainAccentColor: '#000000',
				headerFooterInAllPages: false
			}, 
			data: {} 
		}
	}
	newData = { ...newData, ...values }
	return newData
}


